/**
 * Firebase web app configuration for the lift-assisted-app project.
 *
 * This is the public web config (safe to ship in a client app — it only
 * identifies the Firebase project, it does not grant access). Security is
 * enforced by Firestore rules and the admin custom claim checked in Cloud
 * Functions.
 *
 * Values match lib/config/firebase_config.dart in the Flutter app.
 */
import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyCLX26hlOqdAIFtue6nJvfx7ZjK1WnxoKE',
  authDomain: 'lift-assisted-app.firebaseapp.com',
  projectId: 'lift-assisted-app',
  appId: '1:821259828958:web:e000fb7386e3112dfd8c4f',
  messagingSenderId: '821259828958',
};

/** Singleton Firebase app instance. */
let app: FirebaseApp | null = null;
let authInstance: Auth | null = null;

/** Initialises Firebase (idempotent). Returns the Auth instance. */
export function getFirebaseAuth(): Auth {
  if (!app) {
    app = initializeApp(firebaseConfig, 'lift-assisted-admin');
  }
  if (!authInstance) {
    authInstance = getAuth(app);
  }
  return authInstance;
}
